import styled from '@emotion/styled';

const RiskContainer = styled.div`
  border-radius: 4px;
  padding: 0px 8px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Moderado = styled(RiskContainer)`
  background-color: #50e3c2;
`;

export const Conservador = styled(RiskContainer)`
  background-color: #a5bb43;
`;

export const Arrojado = styled(RiskContainer)`
  background-color: #ed833a;
`;

export const Agressivo = styled(RiskContainer)`
  background-color: #d0021b;
`;

export const RiskName = styled.span`
  font-weight: 700;
  color: #fff;
  font-size: 9px;
`;
